import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue'),
    },
    {
      path: '/original-design',
      name: 'original-design',
      component: () => import('./views/OriginalDesign.vue'),
    },
    {
      path: '/pre-owned-furniture',
      name: 'pre-owned-furniture',
      component: () => import('./views/PreOwnedFurniture.vue'),
    },
    {
      path: '/sold-items',
      name: 'sold-items',
      component: () => import('./views/SoldItems.vue'),
    },
    {
      path: '/product/:slug',
      name: 'product',
      component: () => import('./views/Product.vue'),
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

export default router;
